import type { RouteObject } from 'react-router-dom';

import { Scopes } from '../../api/types';
import { RouteGuard } from '../../components/RouteGuard';
import { DocumentTypeEditorPage } from './pages/DocumentTypeEditorPage';
import { DocumentTypesListPage } from './pages/DocumentTypesListPage';

/**
 * Routes contributed by the Schema Designer feature. The root `src/routes.tsx`
 * merges these into its `children` array — keeping each feature's surface area
 * isolated.
 */
export const schemaRoutes: RouteObject[] = [
  {
    path: 'document-types',
    element: (
      <RouteGuard scope={Scopes.SchemasRead}>
        <DocumentTypesListPage />
      </RouteGuard>
    ),
  },
  {
    path: 'document-types/:slug',
    element: (
      <RouteGuard scope={Scopes.SchemasRead}>
        <DocumentTypeEditorPage />
      </RouteGuard>
    ),
  },
];
